// 9fbef606107a605d69c0edbcd8029e5d
export const ACCOUNT_PAYMENTGC = 'account.paymentGC';
export const lblGcNoPlaceHolder = 'lbl_payment_giftCardNoPlaceholder';
export const lblGcPinPlaceHolder = 'lbl_payment_giftCardPinPlaceholder';
export const lblPaymentSaveToAccount = 'lbl_payment_saveToAccount';
export const lblGcMsgHeading = 'lbl_payment_giftCardMessageHeading';
export const lblGcMsgDesc = 'lbl_payment_giftCardMessageDescription';

const labelsObj = {
  account: {
    paymentGC: {
      referred: [
        {
          name: 'paymentGCTopBanner',
          contentId: '05531e9a-8994-49ec-8bad-8300af924ccd',
          __typename: 'ReferredContent',
        },
      ],
      lbl_payment_heading: 'GIFT CARDS ',
      lbl_payment_ccHeading: 'CREDIT & DEBIT CARDS',
      lbl_payment_ccEmptyAddBtn: 'ADD A CREDIT OR DEBIT CARD',
      lbl_payment_CCEmptyHeading: 'Add a credit or debit card to check out faster!',
      lbl_payment_CCEmptyDesc:
        'Securely save your credit card, and/or My Place Rewards Card information so you can check out even faster!',
      lbl_payment_gcHeading: 'GIFT CARDS & MERCHANDISE CARDS',
      ' lbl_payment_gcEmptyAddBtn': 'ADD GIFT CARD OR MERCHANDISE CREDIT',
      lbl_payment_GCEmptyHeading: 'Have a gift card?',
      lbl_payment_GCEmptyDesc:
        'Save up to 5 gift cards and/or merchandise cards to use the next time you shop.',
      lbl_payment_modalGCHeading: 'Are you sure you want to delete this gift card?',
      lbl_payment_modalCCHeading: 'Are you sure you want to delete this Credit/Debit Card?',
      lbl_payment_modalDeleteCard: 'DELETE CARD',
      lbl_payment_cardNum: 'Card ending in ',
      lbl_payment_expDate: 'Expires on ',
      lbl_payment_defaultCardName: 'Credit Card',
      lbl_payment_venmoAccount: 'Your Venmo Account',
      lbl_payment_giftCard: 'Gift Card',
      lbl_payment_remBal: 'Remaining balance',
      lbl_payment_defaultPayment: 'Default',
      lbl_payment_plccCard: 'Credit Card',
      lbl_payment_venmoHeading: 'VENMO',
      lbl_payment_modalVenmoDelete: 'DELETE VENMO',
      lbl_payment_modalVenmoDeleteHeading:
        'Are you sure you want to delete this saved Venmo payment?',
      lbl_payment_checkBalance: ' Check Balance',
      lbl_payment_addNewAddCta: 'Add A New Address',
      lbl_payment_ccAdressSelect: 'Select from address book',
      lbl_payment_cardNumber: 'Card Number',
      lbl_payment_expMonth: 'Exp. Month',
      lbl_payment_expYear: 'Exp. Year',
      lbl_payment_addCCHeading: 'ADD CREDIT OR DEBIT CARD',
      lbl_payment_editCCHeading: 'EDIT CREDIT OR DEBIT CARD',
      lbl_payment_addBtn: 'ADD NEW CARD',
      lbl_common_delete: 'Delete',
      lbl_common_edit: 'Edit',
      lbl_payment_errorMsg: 'Your action could not be completed due to a system error',
      lbl_payment_GCEmptyAddBtn: 'ADD A GIFT CARD',
      lbl_payment_loading: 'LOADING...',
      lbl_common_makeDefault: 'Make Default',
      lbl_payment_modalGCCancel: "No, Don't Delete",
      lbl_payment_modalGCCardEnd: 'Card ending in ',
      lbl_payment_modalGCConfirm: 'Yes, Delete',
      lbl_payment_gcExpire: ' Expires on ',
      lbl_payment_remainingBalance: 'Remaining balance',
      lbl_payment_successMsg: 'Your account has been updated',
      lbl_payment_billingAddress: 'Billing Address',
      lbl_payment_addGiftCard: 'ADD GIFT CARD OR MERCHANDISE CREDIT',
      lbl_payment_giftCardMessage:
        "<span class='card__msg--bold'>HEADS UP - Don't throw away your gift card!<span><br/><span class='card__msg'>Adding a gift card is a conveinent way to save money in your account for future purchases. However, if you want to use your gift card for an in-sto",
      lbl_payment_addCard: 'SAVE',
      lbl_payment_cancelCard: 'CANCEL',
      lbl_payment_opSuccess: 'Your account has been updated',
      lbl_payment_opFailure: 'Your action could not be completed due to a system error',
      [lblGcNoPlaceHolder]: 'Gift Card / Merchandise Credit Number',
      [lblGcPinPlaceHolder]: 'Pin Number',
      [lblPaymentSaveToAccount]: 'Save gift card balance to my account',
      [lblGcMsgHeading]: "HEADS UP - Don't throw away your gift card!",
      [lblGcMsgDesc]:
        'Adding a gift card is a convienent way to save money in your account on future purchases. However, if you want to use your gift card for an in-store purchase you will need to present the physical card to the cashier.',
      lbl_paymentGC_error_pay_account: 'There was a missing parameter: pay_account',
      lbl_paymentCC_error_pay_expire_month: 'There was a missing parameter: pay_expire_month',
      lbl_paymentCC_error: 'An error occured',
      lbl_paymentGC_error: 'An error occured',
      lbl_paymentCC_error_billing_nickName: 'There was a missing parameter: billing_nickName',
      lbl_paymentCC_error__ERR_DUPLICATE_CARD: 'Please check if the card is already in use.',
      lbl_paymentGC_error__ERR_DUPLICATE_CARD: 'Please check if the card is already in use.',
      lbl_paymentGC_error__ERR_GIFTCARD_INVALID_MESSAGE_SVS07:
        'There was a problem processing your payment, please try again',
      lbl_paymentGC_error__ERR_MAX_LIMIT_REACHED:
        'A maximum of five payment methods may be saved to your account.',
      lbl_paymentCC_error__ERR_MAX_LIMIT_REACHED:
        'A maximum of five payment methods may be saved to your account.',
      lbl_paymentCC_error__CC_TOKENIZATION_REQUEST_FAILED_WITH_CONNECTIVITY_ERROR:
        'There was a problem processing your payment, please try again.',
      lbl_paymentCC_error__CC_TOKENIZATION_REQUEST_FAILED_WITH_CREDIT_CARD_ERROR:
        "We're sorry, we are unable to process your payment information at this time. Please try back later.",
      lbl_paymentCC_error_ERR_CARD_NOT_SUPPORTED: 'This card cannot be added to your wallet.',
      lbl_payment_default: 'DEFAULT',
      lbl_paymentCC_error_payMethodId:
        'The payment method entered could not be authorized for this purchase. Please review the information entered and try again or try an alternate form of payment',
      lbl_mm_yy: 'MM/YY',
      lbl_giftcard_newGiftCard: 'ADD A NEW GIFT CARD',
      lbl_paymentGC_error__ERR_GIFTCARD_SHUTDOWN_SVS15:
        'There was a problem processing your payment, please try with valid gift card',
    },
  },
  checkout: {
    billing: {
      lbl_billing_defaultError:
        'The payment method entered could not be authorized for this purchase. Please review the information entered and try again or try an alternate form of payment',
    },
  },
};

export default labelsObj;
